import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const ContactPage = lazyRouteComponent(() => import('./pages/contact'));
const HelpGuidePage = lazyRouteComponent(() => import('./pages/guide'));
const HelpHomePage = lazyRouteComponent(() => import('./pages/home'));
const PrivacyPolicyPage = lazyRouteComponent(
  () => import('../unauth/pages/legal/privacy-policy'),
);

const IntellectualPropertyPage = lazyRouteComponent(
  () => import('../unauth/pages/legal/intellectual-property'),
);

const TermsOfUsePage = lazyRouteComponent(
  () => import('../unauth/pages/legal/terms-of-use'),
);

const guideRoutes = [
  [ROUTE_PATHS.HOW_TO_BUY, 'Como comprar'],
  [ROUTE_PATHS.PROTECTED_PURCHASE, 'Compra Protegida'],
  [ROUTE_PATHS.RETURNS_AND_CANCELLATIONS, 'Trocas e cancelamentos'],
  [ROUTE_PATHS.FEES, 'Taxas'],
  [ROUTE_PATHS.SHIPPING_GUIDE, 'Envios'],
  [ROUTE_PATHS.PAYMENTS_GUIDE, 'Pagamentos'],
  [ROUTE_PATHS.PAYOUTS_GUIDE, 'Recebimentos e saques'],
  [ROUTE_PATHS.ABOUT, 'Sobre a NexoTCG'],
] as const;

export const getRoutes = (): Route[] => [
  {
    page: HelpHomePage,
    path: ROUTE_PATHS.HELP,
    title: 'Central de Ajuda',
    hidden: true,
    public: true,
  },
  ...guideRoutes.map(([path, title]) => ({
    page: HelpGuidePage,
    path,
    title,
    hidden: true,
    public: true,
  })),
  {
    page: ContactPage,
    path: ROUTE_PATHS.CONTACT,
    title: 'Contato',
    hidden: true,
    public: true,
  },
  {
    page: TermsOfUsePage,
    path: ROUTE_PATHS.TERMS_OF_USE,
    title: 'Termos de Uso',
    hidden: true,
    public: true,
  },
  {
    page: PrivacyPolicyPage,
    path: ROUTE_PATHS.PRIVACY_POLICY,
    title: 'Política de Privacidade',
    hidden: true,
    public: true,
  },
  {
    page: IntellectualPropertyPage,
    path: ROUTE_PATHS.INTELLECTUAL_PROPERTY,
    title: 'Propriedade Intelectual',
    hidden: true,
    public: true,
  },
];
